import * as React from 'react';
import H7 from 'UIComponents/elements/headings/H7';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ScheduledEnrollmentDetailsGroup from 'automation-ui-enrollment/components/scheduledEnrollment/ScheduledEnrollmentDetailsGroup';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScheduledEnrollmentCardContents = ({
  enrollmentSchedule,
  objectTypeId
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H7, {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrollment.canvas.triggerCriteriaHeading"
      })
    }), /*#__PURE__*/_jsx(ScheduledEnrollmentDetailsGroup, {
      enrollmentSchedule: enrollmentSchedule,
      objectTypeId: objectTypeId
    }), /*#__PURE__*/_jsx(H7, {
      className: "m-top-4 m-bottom-2",
      children: objectTypeId === UNKNOWN_ID ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrollment.canvas.refinementCriteriaHeading"
      }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "enrollment.canvas.refinementCriteriaHeading_cob",
        objectTypeId: objectTypeId
      })
    })]
  });
};
export default ScheduledEnrollmentCardContents;